function camelToKebap(string) {
    let newString = string
        .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2")
        .toLowerCase();
    return newString;
}

function objectCamelToKebap(object) {
    for (let key in object) {
        let newKey = camelToKebap(key);
        object[newKey] = object[key];
        if (newKey !== key) {
            delete object[key];
        }
    }
    return object;
}

function stringToFullHex(color) {
    // If a three-character hexcolor, make six-character
    let hexcolor = "#ffffff";
    if (color !== undefined && color !== "") {
        hexcolor = color.substr(1);
        if (hexcolor.length === 3) {
            hexcolor = hexcolor
                .split("")
                .map(function (hex) {
                    return hex + hex;
                })
                .join("");
        }
        hexcolor = "#" + hexcolor;
    }
    return hexcolor;
}

function replaceAt(string, index, replacement) {
    return (
        string.substr(0, index) +
        replacement +
        string.substr(index + replacement.toString().length)
    );
}

export { camelToKebap, objectCamelToKebap, stringToFullHex, replaceAt };
